import { render, staticRenderFns } from "./thread_expired_empty_state.vue?vue&type=template&id=2aadec4a"
import script from "./thread_expired_empty_state.vue?vue&type=script&lang=js"
export * from "./thread_expired_empty_state.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports